import { SVGInterface } from "../../interface";

const Expand = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4 10L4 4L10 4L10 6L7.41 6L10.5 9.09L9.09 10.5L6 7.41L6 10L4 10Z"
      fill={color || "black"}
    />
    <path
      d="M10 18V20H4L4 14H6V16.59L9.09 13.5L10.5 14.91L7.41 18H10Z"
      fill={color || "black"}
    />
    <path
      d="M20 20V14H18V16.59L14.91 13.5L13.5 14.91L16.59 18H14V20H20Z"
      fill={color || "black"}
    />
    <path
      d="M14 4V6H16.59L13.5 9.09L14.91 10.5L18 7.41V10H20V4L14 4Z"
      fill={color || "black"}
    />
  </svg>
);

export default Expand;
